import { z } from 'zod';

export default {
  label: 'Nodal Points', group: 'system',
  description: 'Nodal-point locations for a range of surfaces.',
  settingsSchema: z.strictObject({
    // Installed NODP uses RFD 1 0; zero resolves to I-1 inside CODE V.
    start_surface: z.number().int().default(1).describe('Starting surface, strictly before the resolved ending surface. Native default is 1. CODE V handles out-of-range values with native warnings.'),
    end_surface: z.number().int().default(0).describe('Ending surface. Native default is 0, meaning the surface before the image (I-1).'),
  }),
  parameters: [
    { key: 'start_surface', kind: 'number', label: 'Starting surface', unit: '', integer: true, nullable: false, placeholder: '1' },
    { key: 'end_surface', kind: 'number', label: 'Ending surface (0 = I−1)', unit: '', integer: true, nullable: false, placeholder: '0' },
  ],
  coverage: 'Calculated at the reference wavelength. The range must span at least two surfaces, first surface before last. Distances are in lens units with CODE V\'s signs. Nodal points CODE V cannot determine are left blank, and its warnings for non-rotationally-symmetric lenses are shown.',
} as const;
